import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";
import storage from "@/utils/storage";
import store from "@/store";
import router from "@/router";
import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;

function login(user, password, includeschadensmeldung) {
    return new Promise((resolve) => {
        let data = {};
        data.verfuegernummer = user;
        data.passwort = password;
        data.includeschadensmeldung = includeschadensmeldung;
        const dataString = getDataString(data);
        axios
            .post("?Mode=MeinServicebereich&Function=Login", dataString)
            .then((response) => {
                if (response.data.Status === 200) {
                    store.commit(
                        "setContracts",
                        response.data.Result.vertraege
                    );
                    store.commit(
                        "setChecklists",
                        response.data.Result.checklists
                    );
                    store.cache.delete("user/getUserAddress");
                    store.cache.dispatch("user/getUserAddress");
                    Storage.set({ key: "usernumber", value: user });
                    Storage.set({
                        key: "contracts",
                        value: JSON.stringify(response.data.Result.vertraege),
                    });
                    Storage.set({
                        key: "checklists",
                        value: JSON.stringify(response.data.Result.checklists),
                    });
                    store.commit("setIsLoggedIn", true);
                    // console.log("vor Wechsel auf Dashboard");
                    const afterLoginLink = store.state.afterLoginLink;
                    if (afterLoginLink !== "") {
                        store.commit("setAfterLoginLink", "");
                        router.push(afterLoginLink);
                    } else {
                        router.push({
                            name: "dashboard",
                            params: { user: user, password: password },
                        });
                    }
                }
            })
            .then(() => {
                resolve();
            });
    });
}

function isLoggedIn() {
    return new Promise((resolve, reject) => {
        axios
            .post("?Mode=MeinServicebereich&Function=IsLoggedIn")
            .then((response) => {
                if (
                    response.data.Status === 200 &&
                    response.data.Result.LoggedIn
                ) {
                    if (!store.state.isLoggedIn) {
                        store.commit("setIsLoggedIn", true);
                        store.cache.delete("user/getUserAddress");
                        store.cache.dispatch("user/getUserAddress");
                        storage.setStoreData();
                    }
                    resolve();
                } else {
                    reject();
                }
            });
    });
}

function logout(shouldRedirect = true) {
    axios.post("?Mode=MeinServicebereich&Function=Logout").then((response) => {
        if (response.data.Status === 200) {
            store.commit("setIsLoggedIn", false);
            store.cache.clear();
            storage.removeStoreData();
            // vuex store modules reset state
            store.commit("biketrax/resetState");
            store.commit("coaches/resetState");
            store.commit("contractsDetails/resetState");
            store.commit("contractsTransactions/resetState");
            store.commit("dokbox/resetState");
            store.commit("flexiblelife/resetState");
            store.commit("fonds/resetState");
            store.commit("kreditcheckliste/resetState");
            store.commit("postbox/resetState");
            // store.commit("slidesConfig/resetState");
            store.commit("spontanrueckzahlung/resetState");
            store.commit("unwetterwarnungen/resetState");
            store.commit("user/resetState");
            store.commit("vollwert/resetState");
            if (shouldRedirect) {
                router.push("/dashboard");
            }
        }
    });
}

function getTokenId() {
    return axios.post("?Mode=MeinServicebereich&Function=GetTokenId");
}

export { login, isLoggedIn, logout, getTokenId };
